/** Raw result code of a ledger row derived from a staged over/under score. */
export const OVER_UNDER_DERIVED_RAW_RESULT_CODE = 'DERIVED';
const OVER_NAME_PATTERN = /^over\b/i;
const UNDER_NAME_PATTERN = /^under\b/i;
const TRAILING_NUMBER_PATTERN = /(-?\d+(?:\.\d+)?)\s*$/;
export const isOverUnder = (market) => {
    if (market.selections.length !== 2) {
        return false;
    }
    const names = market.selections.map((selection) => selection.name);
    const hasOver = names.some((name) => OVER_NAME_PATTERN.test(name));
    const hasUnder = names.some((name) => UNDER_NAME_PATTERN.test(name));
    return hasOver && hasUnder;
};
export const parseTrailingNumber = (name) => {
    const match = name.trim().match(TRAILING_NUMBER_PATTERN);
    if (match === null) {
        return null;
    }
    const parsed = Number(match[1]);
    return Number.isFinite(parsed) ? parsed : null;
};
export const resolveOverUnderDirection = (outcomeName) => /^over/i.test(outcomeName) ? 'OVER' : 'UNDER';
export const isCleanOverUnderLine = (line) => {
    const scaled = line * 2;
    return Number.isFinite(scaled) && Math.abs(scaled - Math.round(scaled)) < 1e-9;
};
const resolveLine = (market, outcomeName) => {
    if (market.line !== null && market.line !== undefined) {
        return market.line;
    }
    return parseTrailingNumber(outcomeName);
};
export const resolveOverUnder = (market, outcomeName) => {
    if (!isOverUnder(market)) {
        return { ok: false, reason: 'not_over_under_shape' };
    }
    const line = resolveLine(market, outcomeName);
    if (line === null) {
        return { ok: false, reason: 'unresolved_line' };
    }
    if (!isCleanOverUnderLine(line)) {
        return { ok: false, reason: 'quarter_line' };
    }
    const metadata = {
        settlementType: 'OVER_UNDER',
        direction: resolveOverUnderDirection(outcomeName),
        line,
    };
    return { ok: true, metadata };
};
export const parseOverUnderSettlementMetadata = (value) => {
    if (value === null || typeof value !== 'object') {
        return null;
    }
    const metadata = value;
    if (metadata.settlementType !== 'OVER_UNDER' ||
        (metadata.direction !== 'OVER' && metadata.direction !== 'UNDER') ||
        typeof metadata.line !== 'number' ||
        !Number.isFinite(metadata.line)) {
        return null;
    }
    return {
        settlementType: 'OVER_UNDER',
        direction: metadata.direction,
        line: metadata.line,
    };
};
export const deriveOverUnderResult = (input) => {
    const { score, line, direction } = input;
    if (score === line) {
        return 'PUSH';
    }
    if (direction === 'OVER') {
        return score > line ? 'WIN' : 'LOSE';
    }
    return score < line ? 'WIN' : 'LOSE';
};
//# sourceMappingURL=over-under.js.map